import loadingGif from 'assets/gif/FreeSensLoader05.gif';

const Loading = () => {
  return <img src={loadingGif} style={{height: '45px', width: '45px'}} />;
};

export default Loading;
